import React, { useEffect, useState } from 'react';
import './App.css';
import Base from './components/base/Base';
import RotasLogin from './components/rotas/RotasLogin';

export default function App() {
  const [token, setToken] = useState(() => localStorage.getItem('token'));
  const isProductionPasswordChangePage = window.location.pathname.startsWith('/troca-senha-producao/');

  useEffect(() => {
    const onStorage = () => setToken(localStorage.getItem('token'));
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return token && !isProductionPasswordChangePage ? (
    <Base setToken={setToken} />
  ) : (
    <RotasLogin setToken={setToken} />
  );
}
